import { render } from "./GivingAmount.vue?vue&type=template&id=778fba4c&scoped=true"
import script from "./GivingAmount.vue?vue&type=script&lang=js"
export * from "./GivingAmount.vue?vue&type=script&lang=js"

import "./GivingAmount.vue?vue&type=style&index=0&id=778fba4c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-778fba4c"]])

export default __exports__